import { handleActions, createAction } from 'redux-actions'

const create = (action) => createAction(`interface/zindex/${action}`)

export const setAsTop = create('SET_AS_TOP')

export default handleActions({
  [setAsTop]: (state, action) => action.payload
}, null)
